<template>
  <div class="dropdown">
    <button
      class="btn btn-info dropdown-toggle"
      type="button"
      id="dropdownMenuButton"
      data-toggle="dropdown"
      aria-haspopup="true"
      aria-expanded="false"
    >
      <div class="current-language-container">
        <span
          v-for="(locale, index) in locales"
          :key="index"
          class="current-language"
        >
          <img
            :src="locale.flag"
            :alt="locale.label"
            :title="locale.title"
            v-if="currentLocale == locale.label"
          />
          <span
            class="current-language-title"
            v-if="currentLocale == locale.label"
            >{{ locale.title }}</span
          >
        </span>
      </div>
    </button>
    <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
      <a
        class="dropdown-item"
        v-for="(locale, index) in locales"
        :key="index"
        @click="switchLocale(locale.label)"
      >
        <img :src="locale.flag" :alt="locale.label" :title="locale.title" />
        {{ locale.title }}
      </a>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LocaleSwitcher',
  data() {
    return {
      locales: [
        {
          label: 'en',
          title: 'English',
          flag: 'images/icons/gb.svg',
        },
        {
          label: 'nl',
          title: 'Nederlands',
          flag: 'images/icons/nl.svg',
        },
      ],
      currentLocale: this.$i18n.locale,
    };
  },
  methods: {
    switchLocale(locale) {
      if (this.$i18n.locale !== locale) {
        this.$i18n.locale = locale;
        this.currentLocale = locale;
      }
    },
  },
};
</script>

<style scoped>
ul {
  display: flex;
  align-items: center;
  margin: 0;
  padding: 0;
}

li {
  list-style: none;
  cursor: pointer;
}

li:first-child {
  padding-right: 1rem;
}

img {
  height: 18px;
  width: 18px;
}
</style>